export default __webpack_public_path__ + "static/team5-4dde6f24842b4c6cf78a2e09439b8b71.jpg";